import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import "../Popup/Popup.css";

const Popup = () => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    zip: "",
    phone: "",
    option: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  // Validation function
  const validateField = (name, value) => {
    switch (name) {
      case "name":
        if (!value.trim()) return "Name is required.";
        if (!/^[A-Za-z\s]+$/.test(value.trim()))
          return "Name should contain only alphabets and spaces.";
        return "";
      case "email":
        if (!value.trim()) return "Email is required.";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()))
          return "Invalid email address.";
        return "";
      case "zip":
        if (!value.trim()) return "Zip code is required.";
        if (!/^\d{6}$/.test(value.trim()))
          return "Zip code must be exactly 6 digits.";
        return "";
      case "phone":
        if (!value.trim()) return "Phone number is required.";
        if (!/^\d{10}$/.test(value.trim()))
          return "Phone number must be exactly 10 digits.";
        return "";
      case "option":
        if (!value.trim()) return "Please select an event type.";
        return "";
      case "message":
        if (!value.trim()) return "Message is required.";
        if (value.trim().length < 15)
          return "Message must be at least 15 characters.";
        return "";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };

  const isFormValid = () => {
    return (
      Object.values(formData).every((v) => v.trim() !== "") &&
      Object.values(errors).every((err) => err === "")
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    Object.entries(formData).forEach(([field, value]) => {
      newErrors[field] = validateField(field, value);
    });
    setErrors(newErrors);

    if (Object.values(newErrors).some((err) => err !== "")) {
      return;
    }

    setIsSending(true);

    const serviceID = "service_c2jf13w";
    const templateID = "template_c34kf4z";
    const userID = "UxPRjy8Ztmqt2j8Ls";

    emailjs
      .send(serviceID, templateID, formData, userID)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Sent!",
          text: "Your message has been sent successfully.",
        });
        setFormData({
          name: "",
          email: "",
          zip: "",
          phone: "",
          option: "",
          message: "",
        });
        setErrors({});
        setShow(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong, please try again later.",
        });
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  if (!show) return null;

  return (
    <div className="popup-overlay-ps">
      <div className="popup-container-ps">
        <button
          className="popup-close-btn-ps"
          aria-label="Close popup"
          onClick={() => setShow(false)}
          type="button"
        >
          &times;
        </button>

        <h2 className="popup-heading-ps">Get in Touch for Your Event</h2>
        <p className="popup-subtext-ps">
          Please fill the form below and we will get back to you shortly.
        </p>

        <form className="popup-form-ps" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            className={`input-name-ps ${errors.name ? "input-error-ps" : ""}`}
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            className={`input-email-ps ${errors.email ? "input-error-ps" : ""}`}
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="text"
            name="zip"
            className={`input-zipcode-ps ${errors.zip ? "input-error-ps" : ""}`}
            placeholder="Zip Code"
            value={formData.zip}
            onChange={handleChange}
          />
          <input
            type="text"
            name="phone"
            className={`input-phone-ps ${errors.phone ? "input-error-ps" : ""}`}
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
          />

          <div className="full-width-div-ps">
            <select
              name="option"
              className={`select-eventtype-ps ${errors.option ? "input-error-ps" : ""}`}
              value={formData.option}
              onChange={handleChange}
              required
            >
              <option value="">Select Event Type</option>
              <option value="wedding">Wedding Event</option>
              <option value="corporate">Corporate Event</option>
              <option value="liveConcerts">Live Concerts</option>
              <option value="socialEvents">Social Events</option>
              <option value="others">Others</option>
            </select>
            {errors.option && <p className="error-text-ps">{errors.option}</p>}
          </div>

          <div className="textarea-container-ps">
            <textarea
              name="message"
              className={`textarea-message-ps ${errors.message ? "input-error-ps" : ""}`}
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              minLength={15}
              required
            />
            {errors.message && <p className="error-text-ps">{errors.message}</p>}
          </div>

          <button
            type="submit"
            disabled={isSending || !isFormValid()}
            className="submit-button-ps"
          >
            {isSending ? "Sending..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Popup;
